<template>
<div class="footer">
  <div class="center">
      <div class="footer-top">
          <div class="footer-top-l">
              <img src="@s/skin/web/img/index/weibo.png"  v-show="show1" style="display:inline;" />
          </div>
          <div class="footer-top-c">
              <div class="footer-logo">
                  <a href="/">
                      <img src="@s/skin/web/img/index/dwj-footer-logo.png"/>
                  </a>
                  <p>心相近 乐无垠</p>
              </div>
              <div class="footer-top-c-f">
                  <div class="footer-bo" @mouseenter="show1=true" @mouseleave="show1=false">
                      <img src="@s/skin/web/img/index/bo.png" />
                  </div>
                  <div class="footer-wei" @mouseenter="show2=true" @mouseleave="show2=false">
                      <img src="@s/skin/web/img/index/wei.png" />
                  </div>
              </div>

          </div>
          <div class="footer-top-r">
              <img src="@s/skin/web/img/index/erweima.png"  v-show="show2" style="display:inline;" />
          </div>
      </div>

      <div class="footer-footer" v-if="$store.state.en">
          <p>400 601 8001 (Monday to Friday: 9:00-17:00) Building E46, yard 1, Jinghai 5 road, Taihu Town, Tongzhou District, Beijing</p>
          <p>Copyright © 2018 superplayer Inc. All rights reserved. Beijing public network security 20209546—1 no. Technical support: yi longtian seven star di Technical Support：<a href="http://www.elongtian.com" target="_blank">Yi Longtian</a>·<a href="http://www.qixingdiman.com" target="_blank">Seven stars di</a></p>
      </div>
      
      <div class="footer-footer" v-else>
          <p>400 601 8001 （周一至周五：9:00-17:00） 加盟热线：400 079 8880     北京市通州区台湖镇经海5路1号院E46号楼</p>
          <p>Copyright © 2018 superplayer Inc. 保留所有权利。
京ICP备20029546号—1  技术支持：<a href="http://www.kisgame.cn" target="_blank" style="color:#fff;">武汉融智盛维科技发展有限公司</a></p>
      </div>
  </div>
</div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      show1:false,
      show2:false,
    };
  },
    mounted(){
    function checkNumber(obj, min, max) {
        $(obj).live('mouseenter', function() {
            $(this).children(min).hide()
            $(this).children(max).show()
        }).live('mouseleave', function() {
            $(this).children(min).show()
            $(this).children(max).hide()
        });
    };
    // 调用

    checkNumber('.sy-b-center-a', '.sy-b-center-a-img', '.sy-b-center-a-imglogo');
    checkNumber('.sy-footer', '.sy-footer-img', '.sy-footer-img-se');
  }
}
</script>